import { Flex, Box, Text } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Button, Slider } from 'components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from 'hooks/useBreakpoint';

export interface StepButton {
  label: string;
  onChange: () => void;
}

interface Props {
  nextLabel: string;
  secondNextLabel?: string;
  onSecondNextClick?: () => void;
  backLabel?: string;
  onBackClick?: () => void;
  currentStep: number;
  steps: number;
  isLoading?: boolean;
  isDisabled?: boolean;
  isPaidByPartnerBtnDisabled?: boolean;
  allFlightsCompensatedLabel?: string;
}

const Stepper: FC<Props> = ({
  nextLabel,
  backLabel,
  onBackClick,
  currentStep,
  steps,
  isLoading,
  isDisabled,
  isPaidByPartnerBtnDisabled,
  secondNextLabel,
  onSecondNextClick,
  allFlightsCompensatedLabel,
}) => {
  const { t } = useTranslation('common');
  const { isMobile } = useBreakpoint();

  const stepperValue = Math.ceil((currentStep / steps) * 100);
  return (
    <Flex direction={isMobile ? 'column' : 'row'} alignItems="center" justifyContent="flex-end">
      {!isMobile ? (
        <>
          <Text color="secondary.400" mr={5}>{`Step ${currentStep}/${steps}`}</Text>
          {backLabel ? (
            <Button colorScheme="black" variant="outline" leftIcon={<ArrowBackIcon />} onClick={onBackClick} minW="115px" mr={5}>
              <span>{backLabel}</span>
            </Button>
          ) : null}
        </>
      ) : null}
      {nextLabel && (
        <>
          <Button type="submit" isFullWidth={isMobile} minW="150px" isLoading={isLoading} isDisabled={isDisabled}>
            {nextLabel}
          </Button>
          {allFlightsCompensatedLabel && (
            <Text mt="8px" textAlign="center" fontSize="md">
              {allFlightsCompensatedLabel}
            </Text>
          )}
        </>
      )}
      {secondNextLabel && (
        <Button
          mt="15px"
          variant="outline"
          isFullWidth={isMobile}
          minW="150px"
          isLoading={isLoading}
          isDisabled={isPaidByPartnerBtnDisabled}
          onClick={onSecondNextClick}
        >
          {secondNextLabel}
        </Button>
      )}
      {isMobile ? (
        <>
          <Flex w="100%" mt={'30px'} mb={'30px'} alignItems="center" justifyContent={backLabel ? 'space-between' : 'center'}>
            {backLabel ? (
              <Button
                colorScheme="gray"
                variant="ghost"
                height="auto"
                fontSize="lgMin"
                fontWeight="normal"
                p="5px 3px"
                color="secondary.500"
                leftIcon={<ArrowBackIcon />}
                onClick={onBackClick}
              >
                <Box as="span" ml="8px">
                  {backLabel}
                </Box>
              </Button>
            ) : null}
            <Text color="secondary.400">{`${t('step')} ${currentStep}/${steps}`}</Text>
          </Flex>
          <Slider value={stepperValue} />
        </>
      ) : null}
    </Flex>
  );
};

export default Stepper;
